/* The act dialog's own parts (T-C3 … T-C6): the credit stepper (Base UI's number field) and its
 * hint, the note box, the „Saldo po" projection, and the forgiveness picker's reserved box. The
 * dialog's frame, fields and acts row are `shared/ui/formDialog`'s; the picker's chosen row (an ink
 * ring and an ink dot) is `shared/ui/choiceRow`'s `rowChosenInk`. */

/* The forgiveness list's box: the pending, failed and empty sentences stand in the room two
 * choice rows take, so the note and the acts below never move. */
.pickSet {
  margin: var(--space-0);
  padding: var(--space-0);
  border: 0;
}

.pickState {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  align-items: flex-start;
  justify-content: center;
  min-height: calc(2 * var(--h-assign-row));
  font-size: var(--fs-note);
  font-weight: var(--fw-medium);
  line-height: var(--lh-note);
  color: var(--text-2);
}

/* ── The act dialog ───────────────────────────────────────────────────────────────────────── */
.stepper {
  display: flex;
  gap: var(--space-10px);
  align-items: center;
}

.stepperButton {
  display: grid;
  flex: none;
  width: var(--sz-booking-stepper);
  height: var(--sz-booking-stepper);
  padding: var(--space-0);
  font-family: var(--font-body);
  font-size: var(--fs-field);
  font-weight: var(--fw-bold);
  color: var(--text);
  place-items: center;
  cursor: pointer;
  background: var(--bg-card);
  border: var(--border-hairline) solid var(--border-2);
  border-radius: var(--r-circle);
}

.stepperButton:focus-visible {
  outline: var(--border-focus) solid var(--text);
  outline-offset: var(--space-1px);
}

.stepperButton:hover:not([data-disabled]) {
  background: var(--hover-tint);
}

.stepperButton[data-disabled] {
  color: var(--text-2);
  cursor: not-allowed;
}

.stepperHint {
  font-size: var(--fs-label);
  font-weight: var(--fw-medium);
  color: var(--text-2);
}

.stepperValue {
  width: var(--w-booking-stepper-value);
  height: var(--sz-booking-stepper);
  font-family: var(--font-body);
  font-size: var(--fs-booking-title);
  font-weight: var(--fw-extrabold);
  font-variant-numeric: tabular-nums;
  color: var(--text);
  text-align: center;
  background: var(--bg-inset);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-md);
}

.note {
  min-height: var(--h-booking-note);
  padding-top: var(--space-3);
  padding-bottom: var(--space-3);
  resize: vertical;
}

.after {
  display: flex;
  gap: var(--space-3);
  align-items: center;
  justify-content: space-between;
  margin: var(--space-0);
  padding: var(--space-3) var(--space-4);
  font-size: var(--fs-body);
  font-weight: var(--fw-medium);
  color: var(--text-2);
  border: var(--border-hairline) solid var(--border-2);
  border-radius: var(--radius-md);
}

.afterFigure {
  font-weight: var(--fw-extrabold);
  font-variant-numeric: tabular-nums;
  color: var(--text);
}

/* A field the dialog or the server holds wrong: an ink-weight warning edge two hairlines thick —
 * the plain `--warn` hairline measures under 3:1 on the inset ground in Flame. */
.stepperValue[aria-invalid='true'],
.note[aria-invalid='true'] {
  border-color: var(--warn-ink);
  outline: var(--border-hairline) solid var(--warn-ink);
}

.stepperValue:focus-visible {
  outline: var(--border-focus) solid var(--text);
  outline-offset: var(--space-1px);
}
